import NoMatch from "../app/components/Router/NoMatch.tsx";
import { ADMINISTRATEUR, Authorization, PROCHE } from "../app/droits.tsx";
import url, { urlAuthent } from "../app/module/fetch.tsx";
import CreateRoleUtilisateur from "../app/pages/Utilisateurs/CreateRoleUtilisateur.tsx";
import ImportUtilisateurs from "../app/pages/Utilisateurs/ImportUtilisateurs.tsx";
import GestionRessources from "../app/pages/Ressources/Gestion/GestionRessources.tsx";
import ListUtilisateurs from "../app/pages/Utilisateurs/ListUtilisateurs.tsx";
import UpdateRoleUtilisateur from "../app/pages/Utilisateurs/UpdateRoleUtilisateur.tsx";
import ExportLogConnexion from "../app/pages/Administration/ExportLogConnexion.tsx";
import Accueil from "../public/pages/Accueil/Accueil.tsx";
import AccueilAuth from "../app/pages/Accueil/AccueilAuth.tsx";

export const URLS = {
  ACCUEIL_PRIVE: url`/app`,
  LOGIN: urlAuthent("/"),
  LOGOUT: url`/logout`,
  GESTION_CONTENUS: urlAuthent("/gestion_contenus"),
  GESTION_UTILISATEURS: urlAuthent("/gestion_utilisateurs"),
  EXPORT_DATA: urlAuthent("/export_data"),
  IMPORT_UTILISATEUR: urlAuthent("/import-utilisateurs"),
  UPDATE_ROLE_UTILISATEUR: (utilisateurId: string) =>
    urlAuthent("/gestion_utilisateurs/" + utilisateurId),
  CREATE_ROLE_UTILISATEUR: urlAuthent("/gestion_utilisateurs/create"),
  WEBGL: url`/webgl/`,
};

export default [
  {
    path: "/",
    element: <Authorization Component={Accueil} isPublic={true} />,
  },
  {
    path: "/app/",
    element: (
      <Authorization Component={AccueilAuth} roles={[ADMINISTRATEUR, PROCHE]} />
    ),
  },
  {
    path: "/app/gestion_contenus",
    element: (
      <Authorization Component={GestionRessources} roles={[ADMINISTRATEUR]} />
    ),
  },
  {
    path: "/app/import-utilisateurs",
    element: (
      <Authorization Component={ImportUtilisateurs} roles={[ADMINISTRATEUR]} />
    ),
  },
  {
    path: "/app/gestion_utilisateurs",
    element: (
      <Authorization Component={ListUtilisateurs} roles={[ADMINISTRATEUR]} />
    ),
  },
  {
    path: "/app/gestion_utilisateurs/:utilisateurId",
    element: (
      <Authorization
        Component={UpdateRoleUtilisateur}
        roles={[ADMINISTRATEUR]}
      />
    ),
  },
  {
    path: "/app/gestion_utilisateurs/create",
    element: (
      <Authorization
        Component={CreateRoleUtilisateur}
        roles={[ADMINISTRATEUR]}
      />
    ),
  },
  {
    path: "/app/export_data",
    element: (
      <Authorization Component={ExportLogConnexion} roles={[ADMINISTRATEUR]} />
    ),
  },
  {
    path: "*",
    element: <NoMatch />,
  },
];
